import app from '../api/app';
import { attemptAction } from './index';

export const basicPath = async (dispatch, params, path, type) => {
    async function action(params) {
        let response = null;
        try {
            // For GET requests, use 'params' (query string)
            // For POST/PUT/DELETE requests, send data directly in body
            // Backend expects req.body.params, so we send { params: ... } as the body
            if (type === 'get') {
                response = await app[type](path, {
                    params
                });
            } else {
                // POST, PUT, DELETE - send { params: ... } as request body
                // axios.post(url, data) sends data in req.body
                // axios.put(url, data) sends data in req.body
                // axios.delete(url, { data: {...} }) sends data in req.body
                // So req.body will be { params: {...} } and backend can access req.body.params
                if (type === 'delete') {
                    // DELETE can use query params or body - backend uses req.query for DELETE
                    response = await app[type](path, {
                        params
                    });
                } else {
                    // POST and PUT - send data as second argument (request body)
                    response = await app[type](path, { params });
                }
            }
            
            // Check if response is HTML (SPA fallback) instead of JSON
            if (response && response.data && typeof response.data === 'string' && 
                (response.data.includes('<!doctype') || response.data.includes('<html') || response.data.trim().startsWith('<!'))) {
                console.error('[API] Received HTML instead of JSON for path:', path, 'Status:', response.status);
                console.error('[API] This usually means Nginx is not proxying correctly. Response preview:', response.data.substring(0, 200));
                // Return error response structure
                return {
                    status: 500,
                    statusText: 'Internal Server Error',
                    data: { error: 'Server routing error: Received HTML instead of API response. Nginx proxy may not be configured correctly.' }
                };
            }
        } catch (e) {
            response = e.response;
            console.error('[API] Request failed for path:', path, e);
        } finally {
            if (response) {
                return response;
            } else {
                // Return normalized error object instead of empty object
                // This ensures checkResponses always receives an object with a status property
                return {
                    status: 500,
                    statusText: 'Internal Server Error',
                    data: { error: 'Unknown API error - no response received' }
                };
            }
        }
    };
    return await attemptAction(action, dispatch, params);
}